import { render } from "./song-list-item.vue?vue&type=template&id=349818d9"
import script from "./song-list-item.vue?vue&type=script&lang=js"
export * from "./song-list-item.vue?vue&type=script&lang=js"
script.render = render

export default script